<template>
  <div>
    <v-dialog
      v-model="dialog.show"
      max-width="380"
      persistent>
        <v-card dark>
           <div class="dvDialog-dark">
             <div class="dvDialog-dark-content">
               <div class="dvDialog-dark-content_icon">
                 <div class="dvDialog-dark-content_icon_bg flexCenterAll">
                   <span v-if="!dialog.icon_material" :class="dialog.icon"></span>
                   <i v-if="dialog.icon_material" class="material-icons">{{dialog.icon}}</i>
                 </div>
               </div>
               <div class="dvDialog-dark-content_text">
                 <div class="dvDialog-dark-content_text_title">
                   {{dialog.title}}
                 </div>
                 <div class="dvDialog-dark-content_text_subtitle">
                   {{dialog.body}}
                 </div>
               </div>
             </div>
           </div><!-- dvDialog-dark -->

          <v-card-actions class="dvDialog-dark-btn">
            <v-spacer></v-spacer>
            <v-btn
              v-if="!dialog.negativeBtnWithAction"
              @click="dialog.show = false">
              {{ dialog.negativeBtn }}
            </v-btn>

            <v-btn
              v-if="dialog.negativeBtnWithAction"
              @click="doCancel()">
              {{ dialog.negativeBtn }}
            </v-btn>



            <v-btn class="dvDialog-btn-submit" @click="doConfirm()">
              {{ dialog.positionBtn }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'referral-card-view',
    props: ['dialog'],
    data: () => ({
    }),
    computed: {
    },
    methods: {
      doConfirm (){
        this.$emit('doConfirm')
      },
      doCancel (){
        this.$emit('doCancel')
      },
    },
    mounted() {
    },
    components: {
    }
  }
</script>
